import { render, staticRenderFns } from "./VOrder.vue?vue&type=template&id=3d75ef5e&"
import script from "./VOrder.vue?vue&type=script&lang=js&"
export * from "./VOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports